import axios from 'axios'
import {getToken, isUserLoggedIn} from '@/auth/utils'
import errorCode from '@/auth/errorCode'
import router from '@/router'
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import walletAuth from '@/auth/wallet/auth'
// import useJwt from "@/auth/jwt/useJwt";
// import {initialAbility} from "@/libs/acl/config";
// import store from '@/store/index'
import Vue from "vue";
import Toast from 'vue-toastification'

// Toast Notification Component Styles
// import '@core/scss/vue/libs/toastification.scss'

// console.log(router.push)

Vue.use(Toast, {
    hideProgressBar: true,
    closeOnClick: false,
    closeButton: false,
    icon: false,
    timeout: 3000,
    transition: 'Vue-Toastification__fade',
})

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: process.env.VUE_APP_BASE_URL+process.env.VUE_APP_BASE_API,
    // 超时
    timeout: 600000
})
// request拦截器
service.interceptors.request.use(config => {
    // 是否需要设置 token
    const isLoggedIn = isUserLoggedIn()
    // const userData = getUserData()
    const token = getToken()
    // const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVVUlEIjoiMGQ3YzRjOGYtMmMwOS00NTRkLWJiMDYtYmYzMjdhMWNlYTZlIiwiSUQiOjEsIkV0aEFkZHJlc3MiOiIweDEwMjY2NjFjOTY0MzdmMTQ5MzNhNTQ2OTI0MDgwYWUyYTBiODUxYTMiLCJBdXRob3JpdHlJZCI6IjEiLCJCdWZmZXJUaW1lIjo4NjQwMCwiZXhwIjoxNjQwODc3NDIyLCJpc3MiOiJNYXhpSldUIiwibmJmIjoxNjQwMjcxNjIyfQ.YJoidk4KzPsFMqHaoUXuY4Fie7TmdR9xppEXsZdmrmU'
    if (isLoggedIn) {
        config.headers['x-token'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
    }

    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?';
        for (const propName of Object.keys(config.params)) {
            const value = config.params[propName];
            var part = encodeURIComponent(propName) + "=";
            if (value !== null && typeof (value) !== "undefined") {
                if (typeof value === 'object') {
                    for (const key of Object.keys(value)) {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        url += subPart + encodeURIComponent(value[key]) + "&";
                    }
                } else {
                    url += part + encodeURIComponent(value) + "&";
                }
            }
        }
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;
        // 获取错误信息
        const msg = errorCode[code] || res.data.msg || res.msg || errorCode['default']
        if (code === 401) {
            localStorage.removeItem(walletAuth.config.userData)
            localStorage.removeItem(walletAuth.config.userToken)
            router.replace({name: 'home'})
            Vue.$toast({
                component: ToastificationContent,
                props: {
                    text: msg,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
            return Promise.reject(new Error(msg))
        } else if (code === 7) {
            Vue.$toast({
                component: ToastificationContent,
                props: {
                    text: msg,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
            return Promise.reject(new Error(msg))
        } else if (code === 500) {
            Vue.$toast({
                component: ToastificationContent,
                props: {
                    text: msg,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
            return Promise.reject(new Error(msg))
        } else if (code !== 200) {
            Vue.$toast({
                component: ToastificationContent,
                props: {
                    text: msg,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    error => {
        let {message} = error;
        if (message == "Network Error") {
            // message = "后端接口连接异常";
            message = "connect service error";
        } else if (message.includes("timeout")) {
            // message = "系统接口请求超时";
            message = "connect service timeout";
        } else if (message.includes("Request failed with status code")) {
            // message = "系统接口" + message.substr(message.length - 3) + "异常";
            message = "api" + message.substr(message.length - 3) + "error";
        }
        Vue.$toast({
            component: ToastificationContent,
            props: {
                text: message,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
            },
        })
        return Promise.reject(error)
    }
)
Vue.prototype.$service = service
export default service
